var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"character",style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px"),
  })},[(!_vm.itaijiError)?_c('img',{staticClass:"Character",style:({
      height: (_vm.size + "px"),
      width: (_vm.size + "px"),
    }),attrs:{"src":!_vm.char.imageUrl ? _vm.genItaijiImagePath(_vm.char.character) : _vm.char.imageUrl,"alt":_vm.char.character},on:{"error":_vm.onLoadError,"click":function($event){return _vm._onClickCharacter(_vm.char, _vm.text)}}}):_vm._e(),(_vm.defaultImageError && _vm.itaijiError)?_c('span',{staticClass:"defaultText",style:({ fontSize: ((_vm.size - 10) + "px") })},[_vm._v("\n    "+_vm._s(_vm.char.character)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }